<template>
    <layout :show_footer="false">
        <template v-if="isCiaEnabled">
            <a-breadcrumb class="ml-4 mb-4">
                <a-breadcrumb-item data-cy="breadcrumb-main">
                    <a @click="$router.go(-1)">
                        <template>
                            {{ $t('globals.navigation.header.cia_view.alt_title') }}
                        </template>
                    </a>
                </a-breadcrumb-item>
                <a-breadcrumb-item data-cy="breadcrumb-main">
                    {{ $t('covers.forms.title.cover_info') }}
                </a-breadcrumb-item>
            </a-breadcrumb>

            <form-cover
                data-cy="cover-form"
                :cover="cover"
                :validation="validation"
                :cover_id="cover_id"
                @is-form-dirty="isFormDirty"
                @formSubmit="onSave"
                @update="updateCover"
                @cancel="onCancel"
                ref="CoversForm"
            />
        </template>
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import FormCover from '@/components/forms/Cover.vue';

export default {
    components: {
        Layout,
        FormCover,
    },
    data() {
        let new_start_date = this.$dayjs();
        let new_end_date = this.$dayjs().add(1, 'years').subtract(1, 'day').endOf('day');

        return {
            cover: {
                insurer_id: '',
                company_id: '',
                insurer_policy_number: '',
                broker_policy_number: '',
                policy_start_date: new_start_date.format('YYYY-MM-DD HH:mm:ss'),
                policy_end_date: new_end_date.format('YYYY-MM-DD HH:mm:ss'),
                policy_date_range: {
                    start_date: new_start_date,
                    end_date: new_end_date,
                },
                cover_effective_date: new_start_date.format('YYYY-MM-DD HH:mm:ss'),
                cover_expiry_date: new_end_date.format('YYYY-MM-DD HH:mm:ss'),
                cover_date_range: {
                    start_date: new_start_date,
                    end_date: new_end_date,
                },
                certificate_type: '',
                cover_type: '',
                cover_status: 'active',
                is_motor_trade: false,
                manual_certificate_number: '',
                policyholder_address: '',
                risk_mortgagee: '',
                cover_category: '',
                section_1_label: '',
                section_1: '',
                section_2_label: '',
                section_2: '',
                section_3_label: '',
                section_3: '',
                section_4_label: '',
                section_4: '',
                registration_number: '',
                chassis_number: '',
                vehicle_make: '',
                vehicle_model: '',
                vehicle_year: null,
                vehicle_color: '',
                engine_number: '',
                sum_insured: 0,
                hpcc: '',
                seating: '',
            },
            processing: false,
            form_dirty: false,
            validation: {
                errors: {},
                message: '',
            },
            cover_id: '',
        };
    },
    mounted() {
        this.$refs.CoversForm.dateDifference({
            start_date: this.cover.cover_date_range.start_date.format('YYYY-MM-DD HH:mm:ss'),
            end_date: this.cover.cover_date_range.end_date.format('YYYY-MM-DD HH:mm:ss'),
        });
    },
    computed: {
        isCiaEnabled() {
            return this.$store.state.user.modules.cia;
        },
    },
    methods: {
        isFormDirty(is_dirty) {
            this.form_dirty = is_dirty;
        },
        onSave() {
            if (this.processing) {
                return false;
            }

            this.form_dirty = false;
            this.processing = true;

            let params = {
                ...this.cover,
                company_id: this.cover.insurer_id,
                intermediary_id: this.cover.company_id,
                cover_date_range: null,
                policy_date_range: null,
                policy_start_date: this.cover.policy_date_range.start_date.format('YYYY-MM-DD'),
                policy_end_date: this.cover.policy_date_range.end_date.format('YYYY-MM-DD'),
                cover_effective_date: this.cover.cover_date_range.start_date.format('YYYY-MM-DD'),
                cover_expiry_date: this.cover.cover_date_range.end_date.format('YYYY-MM-DD'),
                policy_start_time: this.cover.policy_date_range.start_date.format('HH:mm:ss'),
                policy_end_time: this.cover.policy_date_range.end_date.format('HH:mm:ss'),
                cover_effective_time: this.cover.cover_date_range.start_date.format('HH:mm:ss'),
                cover_expiry_time: this.cover.cover_date_range.end_date.format('HH:mm:ss'),
            };

            const fm_data = new FormData();

            Object.keys(params).forEach(function (key_value, index) {
                if (params[key_value] === true) {
                    params[key_value] = 1;
                } else if (params[key_value] === false && params[key_value] !== '') {
                    params[key_value] = 0;
                }
            });

            for (var key in params) {
                if (params[key] != null) {
                    fm_data.append(key, params[key]);
                }
            }

            fm_data.append('policy_name_list', JSON.stringify(this.$refs.CoversForm.policy_name_list));

            if (this.$refs.CoversForm.file_list.length > 0) {
                fm_data.append('vehicle_fleet_data', this.$refs.CoversForm.file_list[0]);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            this.$http
                .post('/api/covers', fm_data, { headers })
                .then((response) => {
                    if (response.data.status == 'success') {
                        if (this.$refs.CoversForm.toggle_vehicle_upload_visibility) {
                            this.form_dirty = false;
                            this.$notification.success({
                                message: response.data.message,
                            });

                            this.$router.push({
                                name: 'home-cover-search-all',
                            });
                        } else {
                            this.form_dirty = false;
                            this.cover = {
                                ...this.cover,
                                id: null,
                            };
                            this.$notification.success({
                                message: response.data.message,
                            });

                            this.$router.push({
                                name: 'edit-cover',
                                params: {
                                    id: response.data.cover.id,
                                },
                            });
                        }
                    } else if (response.data.status == 'warning') {
                        this.form_dirty = false;
                        this.$notification.warning({
                            message: response.data.message,
                        });

                        this.$router.push({
                            name: 'home-cover-search-all',
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCA0134' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        updateCover(value) {
            this.cover = {
                ...this.cover,
                ...value,
            };
        },
        onCancel() {
            this.$router.go(-1);
        },
    },
};
</script>
